export const RATIO = { x: 16, y: 9 };